import { Box, Flex, Image } from '@chakra-ui/react';
import Motif from '@/components/brand/motif';
import { Workspace } from '@/lib/types';

// DS-documented fixed gradient for the home hero band (Hero.jsx).
// Default banner when the workspace has no banner_image; also the
// underlay while a banner_image is loading.
const DS_HERO_GRADIENT = 'linear-gradient(120deg,#0E2A2A,#16403B 60%,#1d5a4f)';

type WorkspaceLike = {
  name?: string;
  logo?: string;
  banner_logo?: string;
  banner_image?: string;
};

type Props = {
  workspace: Workspace | WorkspaceLike | null;
};

export default function HomeBanner({ workspace }: Props) {
  const bannerImage = workspace?.banner_image;

  return (
    <Box mx='auto' width={{ md: '90%' }} maxW='6xl' px={{ base: 4, md: 0 }} pt={{ base: 3, md: 4 }}>
      <Box
        position='relative'
        width='100%'
        minH={{ base: '170px', md: '220px' }}
        borderRadius='lg'
        overflow='hidden'
        background={
          bannerImage
            ? `url(${bannerImage}) center / cover no-repeat, ${DS_HERO_GRADIENT}`
            : DS_HERO_GRADIENT
        }
        shadow='lg'
      >
        {bannerImage ? (
          // darkening scrim so the logo card stays legible on arbitrary photos
          <Box
            position='absolute'
            inset={0}
            background='linear-gradient(180deg, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.45) 100%)'
            pointerEvents='none'
          />
        ) : (
          // Full-color motif — DS spec: color variant bleeding off the top-right
          <Box
            position='absolute'
            top='-28px'
            right='-20px'
            opacity={0.85}
            pointerEvents='none'
            aria-hidden='true'
          >
            <Motif size={150} variant='color' />
          </Box>
        )}
        <Flex
          position='relative'
          direction='column'
          align='center'
          justify='center'
          height='100%'
          py={{ base: 8, md: 10 }}
          gap={3}
        >
          <Box
            w={{ base: '92px', md: '112px' }}
            h={{ base: '92px', md: '112px' }}
            bg='bg.panel'
            borderRadius='md'
            display='flex'
            alignItems='center'
            justifyContent='center'
            shadow='md'
            overflow='hidden'
          >
            <Image
              src={workspace?.banner_logo || workspace?.logo || '/logo.png'}
              alt={workspace?.name || 'Workspace'}
              maxH='80%'
              maxW='80%'
              objectFit='contain'
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}
